<humi-logo
    *showIfFlag="'humi-rebrand-2024'"
    [variant]="variant"
    [labelOrientation]="labelOrientation"
    [ariaLabel]="ariaLabel | translate"
/>
<img *hideIfFlag="'humi-rebrand-2024'" [src]="legacyVanillaLogoPath" [class]="size" />
